/**
 * シナリオ生成で選択中の商品 (ASIN または手動商品) を、選択素材エリアなど ScenarioGenerator の外からも
 * 読めるように公開する小さなストア。書き込みは useProductSelection だけ (アンマウント時に空へ戻す)。
 * 「商品画像を復元」(SelectedAssetsPanel) が、商品に紐づく画像素材と選択中素材を照合するのに使う。
 */
import { create } from 'zustand';

export interface SelectedProductRef {
  asin: string | null;
  manualProductId: string | null;
}

interface SelectedProductState extends SelectedProductRef {
  setSelectedProduct: (ref: SelectedProductRef) => void;
  clearSelectedProduct: () => void;
}

export const useSelectedProductStore = create<SelectedProductState>((set) => ({
  asin: null,
  manualProductId: null,
  setSelectedProduct: ({ asin, manualProductId }) => set({ asin: asin || null, manualProductId: manualProductId || null }),
  clearSelectedProduct: () => set({ asin: null, manualProductId: null }),
}));
